import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-audio-transcript',
  templateUrl: './audio-transcript.component.html',
  styleUrl: './audio-transcript.component.scss'
})
export class AudioTranscriptComponent implements OnInit {
  @Input() transcriptData: any[] = [];
  @Input() currentSegmentIndex: number | null = null;
  @Input() isPlayerDetached: boolean = false;
  @Input() isTranscriptEnabled: boolean = false;
  @Output() closeTranscript: EventEmitter<void> = new EventEmitter<void>();
  dragPosition = { x: 0, y: 0 };

  ngOnInit() { }

  onCloseClick(): void {
    this.closeTranscript.emit();
  }

  onDragEnded(event: any): void {
    this.dragPosition = event.source.getFreeDragPosition();
  }

  getDynamicPosition(): { top: string; right: string; position?: string; zIndex?: number } {
    return this.isPlayerDetached
      ? { top: '0px', right: '0px', position: 'fixed', zIndex: 100 } // Player Detached
      : { top: '569px', right: '25px' }; // Player not detached
  }

  getConditionalStyles(): { [key: string]: string } {
    if (this.isPlayerDetached) {
      return { top: '70px', right: '450px' };
    } else {
      return { top: '569px', right: '25px' };
    }
  }

}

